// Rostos SVG minimalistas — 5 estados emocionais via arcos
const MoodFace = ({ score, size = 30 }) => {
  const cx = size / 2, cy = size / 2, r = size * 0.42;

  const mouths = {
    1: `M ${cx - r*0.44} ${cy + r*0.28} Q ${cx} ${cy + r*0.02} ${cx + r*0.44} ${cy + r*0.28}`,
    2: `M ${cx - r*0.42} ${cy + r*0.32} L ${cx + r*0.42} ${cy + r*0.32}`,
    3: `M ${cx - r*0.4} ${cy + r*0.28} Q ${cx} ${cy + r*0.52} ${cx + r*0.4} ${cy + r*0.28}`,
    4: `M ${cx - r*0.44} ${cy + r*0.18} Q ${cx} ${cy + r*0.62} ${cx + r*0.44} ${cy + r*0.18}`,
    5: `M ${cx - r*0.46} ${cy + r*0.08} Q ${cx} ${cy + r*0.74} ${cx + r*0.46} ${cy + r*0.08}`,
  };

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx={cx} cy={cy} r={r} />
      <circle cx={cx - r*0.28} cy={cy - r*0.22} r={r*0.07} fill="currentColor" stroke="none" />
      <circle cx={cx + r*0.28} cy={cy - r*0.22} r={r*0.07} fill="currentColor" stroke="none" />
      <path d={mouths[score]} />
    </svg>
  );
};

const MOODS = [
  { score: 1, label: 'Difícil' },
  { score: 2, label: 'Neutro' },
  { score: 3, label: 'Ok' },
  { score: 4, label: 'Bem' },
  { score: 5, label: 'Ótimo' },
];

export default function MoodPicker({ value, onChange, disabled }) {
  return (
    <div className="mood-picker">
      <p className="mood-picker-label">Como você está hoje?</p>
      <div className="mood-options">
        {MOODS.map(m => (
          <button
            key={m.score}
            className={`mood-option ${value === m.score ? 'selected' : ''}`}
            data-mood={m.score}
            onClick={() => !disabled && onChange(m.score)}
            disabled={disabled}
            type="button"
          >
            <span className="mood-svg"><MoodFace score={m.score} /></span>
            <span className="mood-text">{m.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
